var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "9px",
    viewBox: "0 0 10 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MANAGE-PLAN-(1)-Copy-2",
    transform: "translate(-514.000000, -257.000000)",
    fill: "#6236ff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(508.000000, 251.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    points: "11 13.5 8.06107374 15.045085 8.62235871 11.7725425 6.24471742 9.45491503 9.53053687 8.97745751 11 6 12.4694631 8.97745751 15.7552826 9.45491503 13.3776413 11.7725425 13.9389263 15.045085"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBlue);
export default __webpack_public_path__ + "static/media/Star-blue.ab4b9523ae306ba25492fa0a5f319e55.svg";
export { ForwardRef as ReactComponent };